var Constant = {
	clientUrl:"/",
	//根据当前环境修改
	serverUrl:process.env.VUE_APP_BACKEND_URL
};

export default Constant;